const STARCH_KEYWORDS = /\b(bean|beans|rice|bread|pasta|potato|potatoes|toast|quinoa|tortilla|wrap|bun|roll|noodle|noodles|chili|chilli|corn|cracker|crackers|cereal|oatmeal|oats|grain|grains|flour|bagel|muffin|pizza|sandwich|macaroni|spaghetti|noodles)\b/i;
const OZ_PATTERN = /\b(\d+(?:\.\d+)?)\s*(?:oz|ounce|ounces)\b/gi;
function parseMaxOz(description) {
    const matches = [...description.matchAll(OZ_PATTERN)];
    if (matches.length === 0) {
        return null;
    }
    return Math.max(...matches.map(m => parseFloat(m[1])));
}
function prettyDayType(dayType) {
    if (dayType === 'loss') {
        return 'Loss day';
    }
    if (dayType === 'maintenance') {
        return 'Maintenance day';
    }
    return 'Reward day';
}
function normalizeGender(gender) {
    if (gender == null) {
        return null;
    }
    const g = String(gender).trim().toUpperCase();
    if (g === 'M' || g === 'MALE') {
        return 'M';
    }
    if (g === 'F' || g === 'FEMALE') {
        return 'F';
    }
    return null;
}
export function coachInsightFlagLabel(flag) {
    switch (flag) {
        case 'OFF_PLAN':
            return 'Off plan for this day type';
        case 'TYPE_MISMATCH':
            return 'Meal type does not match the day';
        case 'LOW_CONFIDENCE':
            return 'Low classifier confidence — review label';
        case 'POSSIBLE_STARCH_ON_LOSS_DAY':
            return 'Possible starch or grain on a loss day';
        case 'PROTEIN_PORTION_HIGH_WOMAN':
            return 'Protein portion above Woman loss-day range (3–6 oz)';
        case 'PROTEIN_PORTION_HIGH_MAN':
            return 'Protein portion above Man loss-day range (6–8 oz)';
        case 'PROTEIN_PORTION_LOW_MAN':
            return 'Protein portion below Man loss-day minimum (6 oz)';
        default:
            return flag;
    }
}
export function buildCoachInsights(input) {
    const flags = [];
    const summaryParts = [
        prettyDayType(input.expectedType),
        `classified ${input.classifiedType}`,
    ];
    if (input.offPlan) {
        flags.push('OFF_PLAN');
        if (input.classifiedType !== input.expectedType) {
            flags.push('TYPE_MISMATCH');
        }
    }
    if (input.confidence != null && input.confidence < 0.6) {
        flags.push('LOW_CONFIDENCE');
    }
    if (input.expectedType === 'loss' && STARCH_KEYWORDS.test(input.description)) {
        flags.push('POSSIBLE_STARCH_ON_LOSS_DAY');
        summaryParts.push('possible starch');
    }
    const gender = normalizeGender(input.gender);
    const maxOz = parseMaxOz(input.description);
    if (maxOz != null && input.expectedType === 'loss') {
        if (gender === 'F' && maxOz > 6) {
            flags.push('PROTEIN_PORTION_HIGH_WOMAN');
        }
        else if (gender === 'M') {
            if (maxOz > 8) {
                flags.push('PROTEIN_PORTION_HIGH_MAN');
            }
            else if (maxOz < 6) {
                flags.push('PROTEIN_PORTION_LOW_MAN');
            }
        }
    }
    return {
        flags,
        summary: summaryParts.join(' · '),
    };
}
/** Multi-line tooltip for admin Meal Map (CI3.1). */
export function formatCoachInsightTooltip(insights) {
    const lines = [insights.summary];
    for (const flag of insights.flags) {
        if (flag === 'OFF_PLAN') {
            continue;
        }
        lines.push(`• ${coachInsightFlagLabel(flag)}`);
    }
    return lines.join('\n');
}
